import { Control, Controller, FieldErrors, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EmployeesIndexed } from '~/data/employees';
import { useSxStyles } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmployment/components/FormComponent/components/Common/useStyles';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import { LegacyAutocompleteField } from '~/legacy-components/LegacyForms';

type Props = {
  control: Control<Form>;
  managers: number[];
  allEmployees: EmployeesIndexed;
  errors: FieldErrors<Form>;
  index: number;
};

export const ManagerComponent = ({
  control,
  managers,
  allEmployees,
  errors,
  index,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  // @ts-ignore
  useWatch({
    control,
    name: `schedule.${index}.empPosition.fInternalPositionUnit`,
  });

  return (
    <Controller
      control={control}
      rules={{
        required: false,
        validate: (value) => {
          if (!value) return true;
          // Is valid employee Id
          const num = parseInt(value);
          return !isNaN(num);
        },
      }}
      name={`schedule.${index}.empPosition.fInternalPositionManager`}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <LegacyAutocompleteField
          fieldError={error}
          sx={sxStyles.selectStyle}
          placeholder={''}
          options={managers}
          getOptionLabel={(c) =>
            `${allEmployees[c]?.fEmpLastName || ''}, ${
              allEmployees[c]?.fEmpFirstName || ''
            }`
          }
          onChange={(e, value) => {
            onChange(value ? value.toString() : '-1');
          }}
          value={managers.find((mg) => mg.toString() === value) || null}
          label={t('laManager')}
        />
      )}
    />
  );
};
